import { render, staticRenderFns } from "./FullButton.vue?vue&type=template&id=6db919a6"
import script from "./FullButton.vue?vue&type=script&lang=js"
export * from "./FullButton.vue?vue&type=script&lang=js"
import style0 from "./FullButton.vue?vue&type=style&index=0&id=6db919a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports